import React, {useContext} from 'react';
import {Size, TextArea} from "@dts-soldel/dts-react-common";
import MobXContext from "../../../../app/mobx/MobXContext";
import {observer} from "mobx-react";
import PropTypes from "prop-types";
import HelpIcon from "../../HelpIcon/HelpIcon";
import HelpText from "../../HelpIcon/HelpText";

const propTypes = {
	iconName: PropTypes.string.isRequired,
};
const defaultProps = {};

const IconInputOnClick = ({iconName}) => {
	const {configuratorStore} = useContext(MobXContext);

	return (
		<TextArea
			size={Size.FULL_WIDTH}
			field={`${iconName}IconOnClick`}
			label="onClick"
			value={configuratorStore[`${iconName}IconOnClick`]}
			onChange={configuratorStore.setFieldValue}
			children={
				<HelpIcon
					popOverText={HelpText[`${iconName}IconOnClick`]}
					onUseExampleField={HelpText[`${iconName}IconOnClick`].exampleValue ? `${iconName}IconOnClick` : undefined}
					onUseExampleFieldValue={HelpText[`${iconName}IconOnClick`].exampleValue ? configuratorStore.setFieldValue : undefined}
				/>
			}
		/>
	);
};

IconInputOnClick.propTypes = propTypes;
IconInputOnClick.defaultProps = defaultProps;

export default observer(IconInputOnClick);
